const eventList = ['touchmove', 'wheel'] as const;

const preventDefaultHandler = (event: Event): void => {
  event.preventDefault();
};

export const FixBodyUtil = {
  lastScrollY: 0,
  fix: () => {
    eventList.forEach((event) => {
      document.body.addEventListener(event, preventDefaultHandler, { passive: false });
    });
  },
  restore: () => {
    eventList.forEach((event) => {
      document.body.removeEventListener(event, preventDefaultHandler);
    });
  },
};
